export type AuditLogEntry = {
  action: string;
  entities: AuditLogSubject[];
};

export type AuditLogSubject = {
  id: string;
  entity: string;
};

export enum AuditLogEntityType {
  API_KEY = 'API_KEY',
  DEVICE = 'DEVICE',
  USER = 'USER',
  ZONE = 'ZONE',
  ROI = 'ROI',
  SITE = 'SITE',
  CUSTOMER = 'CUSTOMER',
}

export const AuditLogEntityTypeMap = {
  [AuditLogEntityType.API_KEY]: 'Api Key',
  [AuditLogEntityType.DEVICE]: 'Device',
  [AuditLogEntityType.USER]: 'User',
  [AuditLogEntityType.ZONE]: 'Zone',
  [AuditLogEntityType.ROI]: 'ROI',
  [AuditLogEntityType.SITE]: 'Site',
  [AuditLogEntityType.CUSTOMER]: 'Customer',
};

export enum AuditLogActorType {
  USER = 'USER',
}

export enum AuditLogAction {
  CREATE_DEVICE_API_KEY = 'CREATE_DEVICE_API_KEY',
  DELETE_DEVICE_API_KEY = 'DELETE_DEVICE_API_KEY',

  CREATE_CUSTOMER_API_KEY = 'CREATE_CUSTOMER_API_KEY',
  DELETE_CUSTOMER_API_KEY = 'DELETE_CUSTOMER_API_KEY',

  CREATE_DEVICE = 'CREATE_DEVICE',
  UPDATE_DEVICE = 'UPDATE_DEVICE',
  DELETE_DEVICE = 'DELETE_DEVICE',
  CREATE_DEVICE_BATCH = 'CREATE_DEVICE_BATCH',

  ASSIGN_USER_TO_DEVICE = 'ASSIGN_USER_TO_DEVICE',
  ASSIGN_USER_TO_DEVICES_BATCH = 'ASSIGN_USER_TO_DEVICES_BATCH',
  UNASSIGN_USER_FROM_DEVICE = 'UNASSIGN_USER_FROM_DEVICE',

  UPDATE_DEVICE_ZONE_ROI = 'UPDATE_DEVICE_ZONE_ROI',

  CREATE_SITE = 'CREATE_SITE',
  UPDATE_SITE = 'UPDATE_SITE',
  DELETE_SITE = 'DELETE_SITE',
  UPDATE_SITE_USER_DATA = 'UPDATE_SITE_USER_DATA',

  ASSIGN_DEVICE_TO_SITE = 'ASSIGN_DEVICE_TO_SITE',
  UNASSIGN_DEVICE_FROM_SITE = 'UNASSIGN_DEVICE_FROM_SITE',

  UPDATE_SITE_LOCATION = 'UPDATE_SITE_LOCATION',

  CREATE_CUSTOMER = 'CREATE_CUSTOMER',
  UPDATE_CUSTOMER = 'UPDATE_CUSTOMER',
  DELETE_CUSTOMER = 'DELETE_CUSTOMER',

  UPSERT_CUSTOMER_SECRET = 'UPSERT_CUSTOMER_SECRET',
  DELETE_CUSTOMER_SECRET = 'DELETE_CUSTOMER_SECRET',
}

export const AuditLogActorMap = {
  [AuditLogActorType.USER]: 'User',
};

export const AuditLogActionMap = {
  [AuditLogAction.CREATE_DEVICE_API_KEY]: 'Create device API key',
  [AuditLogAction.DELETE_DEVICE_API_KEY]: 'Delete device API key',

  [AuditLogAction.CREATE_CUSTOMER_API_KEY]: 'Create customer API key',
  [AuditLogAction.DELETE_CUSTOMER_API_KEY]: 'Delete customer API key',

  [AuditLogAction.CREATE_DEVICE]: 'Create device',
  [AuditLogAction.UPDATE_DEVICE]: 'Update device',
  [AuditLogAction.DELETE_DEVICE]: 'Delete device',
  [AuditLogAction.CREATE_DEVICE_BATCH]: 'Create device batch',

  [AuditLogAction.ASSIGN_USER_TO_DEVICE]: 'Assign user to device',
  [AuditLogAction.ASSIGN_USER_TO_DEVICES_BATCH]:
    'Assign user to devices (bulk)',
  [AuditLogAction.UNASSIGN_USER_FROM_DEVICE]: 'Unassign user from device',

  [AuditLogAction.UPDATE_DEVICE_ZONE_ROI]: 'Update device zone ROI',

  [AuditLogAction.CREATE_SITE]: 'Create site',
  [AuditLogAction.UPDATE_SITE]: 'Update site',
  [AuditLogAction.DELETE_SITE]: 'Delete site',
  [AuditLogAction.UPDATE_SITE_USER_DATA]: 'Update site user data',

  [AuditLogAction.ASSIGN_DEVICE_TO_SITE]: 'Assign device to site',
  [AuditLogAction.UNASSIGN_DEVICE_FROM_SITE]: 'Unassign device from site',

  [AuditLogAction.UPDATE_SITE_LOCATION]: 'Update site location',

  [AuditLogAction.CREATE_CUSTOMER]: 'Create customer',
  [AuditLogAction.UPDATE_CUSTOMER]: 'Update customer',
  [AuditLogAction.DELETE_CUSTOMER]: 'Delete customer',
  [AuditLogAction.UPSERT_CUSTOMER_SECRET]: 'Create or update customer secret',
  [AuditLogAction.DELETE_CUSTOMER_SECRET]: 'Delete customer secret',
};
